import { gql } from '@apollo/client';

/**
 * GraphQL query for searching cases
 *
 * Moved from domain-specific location to core GraphQL queries
 * to follow established pattern (per PR feedback #116866648)
 */
export const SEARCH_CASES = gql`
  query SearchCases($input: CaseSearchInput!) {
    searchCases(input: $input) {
      results {
        data
      }
      totalCount
    }
  }
`;
